import {UIMSingletonPageController} from '../ui_fullscreen/UIMSingletonPageController'
import {UIMAdController} from '../ui_ad/UIMAdController'
import {UIMMainPageController} from './main_page/UIMMainPageController'
import {UIMSceneController} from './UIMSceneController'
import {UIMFullscreenPageController} from '../ui_fullscreen/UIMFullscreenPageController'
import {UIMCreateRoomController} from './room/UIMCreateRoomController'
import {stripOAuthTokenFromUrl} from '../../../shared/scripts/ui_utils/TestableClientUtils'
import {UIMLoginController} from '../UIMLoginController'
import {UIMDeviceHandler} from './UIMDeviceHandler'
import {UIVLIController} from '../../../shared/scripts/ui_ad/UIVLIController'
import {UIMManagerEvents} from './UIMManagerEvents'
import {UIMGameOrientationController} from '../UIMGameModeController'
import {UIMRequestPushNotification, PushNotificationPopupIntentEnum} from '../ui_popup/UIMRequestPushNotification'
import {UIUtilsFriends} from '../../../shared/scripts/ui_friends/UIUtilsFriends'
import {UIVersionController} from '../../../shared/scripts/UIVersionController'

export class UIMManager {
    readonly uiManagerEvents: UIMManagerEvents
    readonly singletonPageController: UIMSingletonPageController
    readonly adController: UIMAdController
    readonly sceneController: UIMSceneController
    readonly mainpageController: UIMMainPageController
    readonly fullscreenPageController: UIMFullscreenPageController
    readonly createRoomController: UIMCreateRoomController
    readonly vliController: UIVLIController
    readonly loginController: UIMLoginController

    constructor() {
        new UIMGameOrientationController()
        this.uiManagerEvents = new UIMManagerEvents(this)
        this.sceneController = new UIMSceneController(this)
        this.createRoomController = new UIMCreateRoomController()
        this.mainpageController = new UIMMainPageController(this.sceneController)
        this.singletonPageController = new UIMSingletonPageController(this.mainpageController)
        this.adController = new UIMAdController(this)
        this.fullscreenPageController = new UIMFullscreenPageController()
        this.vliController = new UIVLIController()
        this.loginController = new UIMLoginController()

        stripOAuthTokenFromUrl()

        void ((window as any).deviceHandler = UIMDeviceHandler)
        this.initializePushNotificationPopup()
    }

    init() {
        this.singletonPageController.handleUrlRedirect(window.location.href)
        this.createRoomController.init()
    }

    // eslint-disable-next-line class-methods-use-this
    private initializePushNotificationPopup() {
        UIUtilsFriends.callbackActionOnFriendRequestSent.push(() => {
            new UIMRequestPushNotification(PushNotificationPopupIntentEnum.OnUserSentFriendRequest)
        })

        UIVersionController.patchNoteRemoveAction = () => {
            new UIMRequestPushNotification(PushNotificationPopupIntentEnum.OnUserClosesPatchNotesScreen)
        }
    }
}
